import { Link } from "react-router-dom";
import { articles } from "@/mocks/content";

const tickerItems = [...articles]
  .sort((a, b) => b.views - a.views)
  .slice(0, 8);

export default function TrendingTicker() {
  const row = [...tickerItems, ...tickerItems];

  return (
    <section className="w-full bg-primary-500 overflow-hidden mt-12" aria-label="实时热门话题滚动条">
      <div className="flex items-center">
        <div className="flex-shrink-0 flex items-center gap-2 px-4 md:px-6 h-11 bg-primary-600 text-background-50">
          <span className="w-4 h-4 flex items-center justify-center">
            <i className="ri-fire-fill text-base" />
          </span>
          <span className="text-xs md:text-sm whitespace-nowrap">实时热门</span>
        </div>
        <div className="relative flex-1 overflow-hidden h-11">
          <div className="flex items-center h-full animate-scroll-x w-max">
            {row.map((a, i) => (
              <Link
                key={`${a.id}-${i}`}
                to={`/article/${a.id}`}
                className="flex items-center gap-2 px-6 text-xs md:text-sm text-background-50/95 hover:text-white cursor-pointer whitespace-nowrap"
              >
                <span className="w-1.5 h-1.5 rounded-full bg-accent-300" />
                {a.title}
              </Link>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}